import Cookies from 'js-cookie';

const AUTH_COOKIE_NAME = 'auth_access_token';

/**
 * Authentication helper
 */
class AuthHelper {
    /**
     * Gets the user session data stored in the access token cookie, if any
     * @return {Object}
     */
    getSessionToken(): Record<string, string> {
        const authCookie = Cookies.get(AUTH_COOKIE_NAME);
        if (authCookie) {
            const token = this.parseJWT(authCookie);

            if ('sub' in token) {
                return token;
            }
        }

        return {};
    }

    /**
     * Returns the user identifier stored in the user session data
     * @return {String}
     */
    getUserIdentifier(): string {
        const sessionToken = this.getSessionToken();
        return 'sub' in sessionToken ? sessionToken['sub'] : '';
    }

    /**
     * Parses a JWT token and returns the payload
     * @param {String} token
     * @return {Object}
     */
    parseJWT(token: string): any {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }
}

export { AuthHelper as default };
